'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBug = function FaBug(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.9 21.4q0 0.6-0.4 1t-1 0.5h-5q0 3.8-1.5 6.4l4.6 4.7q0.5 0.4 0.5 1t-0.5 1q-0.4 0.4-1 0.4t-1-0.4l-4.4-4.4q-0.1 0.1-0.3 0.3t-1 0.6-1.4 0.8-1.8 0.7-2.2 0.3v-20h-2.9v20q-1.1 0-2.2-0.3t-2-0.8-1.4-0.8-1-0.8l-0.3-0.3-4.1 4.7q-0.5 0.4-1.1 0.4-0.5 0-1-0.3-0.4-0.4-0.4-1t0.3-1.1l4.5-5q-1.3-2.6-1.3-6.1h-5q-0.5 0-1-0.5t-0.4-1 0.4-1 1-0.4h5v-6.6l-3.8-3.8q-0.4-0.4-0.4-1t0.4-1 1-0.5 1 0.5l3.8 3.8h18.9l3.9-3.8q0.4-0.5 1-0.5t1 0.5 0.4 1-0.4 1l-3.9 3.8v6.6h5q0.6 0 1 0.4t0.4 1z m-10.7-12.8h-14.3q0-3 2.1-5.1t5.1-2.1 5 2.1 2.1 5.1z' })
        )
    );
};

exports.default = FaBug;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/bug.js
// module id = 1557
// module chunks = 168707334958949